import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * For-Business CTA — always routes to the new lead capture form.
 * `ready` remains in the API so existing callers rendering a disabled
 * loading state stay happy; there's no auth prefetch to wait on any more.
 */
export function useBusinessCta() {
  const navigate = useNavigate();
  const onClick = useCallback(() => navigate("/business/apply"), [navigate]);
  return { ready: true, isAuthed: false, onClick };
}
